import { differenceInYears } from "date-fns";

const MIN_AGE = 6;
const MAX_AGE_EXCLUSIVE = 16;

export const isSwissFamilyCardChildAge = (birthDate: Date, referenceDate: Date = new Date()): boolean => {
  const age = differenceInYears(referenceDate, birthDate);
  return age >= MIN_AGE && age < MAX_AGE_EXCLUSIVE;
};

export const hasSwissFamilyCardEligibleChild = (
  passengers: Array<{ birthDate: Date | string }>,
  referenceDate: Date = new Date()
): boolean => {
  return passengers.some(passenger => {
    const birthDate = passenger.birthDate instanceof Date ? passenger.birthDate : new Date(passenger.birthDate);
    return isSwissFamilyCardChildAge(birthDate, referenceDate);
  });
};
